import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';

import type { TagDemographic, TagFilter } from './types';

// Send numeric ids as JSON numbers and UUIDs as JSON strings so the backend
// DTO accepts either shape during the NAT-653 migration window.
const toWireReportId = (reportId: string): number | string =>
  /^[1-9]\d*$/.test(reportId) ? Number(reportId) : reportId;

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: retry(axiosBaseQuery(), { maxRetries: 0 }),
  endpoints: (builder) => ({
    getDemographics: builder.query<TagDemographic[], { reportId: string; filters?: TagFilter[] }>({
      query: ({ reportId, filters }) => ({
        url: '/tags/demographics',
        method: 'POST',
        data: { reportId: toWireReportId(reportId), filters: filters ?? [] },
      }),
    }),
  }),
});

export const { useGetDemographicsQuery } = tagsApi;
